enum IndexV2Enum {
  'home_nav.category_all' = 'home_nav.category_all',
  'home_nav.top_brands' = 'home_nav.top_brands',
  'home_nav.new_arrivals' = 'home_nav.new_arrivals',
  'home_nav.country_selection' = 'home_nav.country_selection',
  'home_nav.collections' = 'home_nav.collections',
  'home_nav.limited_edition' = 'home_nav.limited_edition',
  'home_nav.old_and_rare' = 'home_nav.old_and_rare',
  'home_nav.sell_now' = 'home_nav.sell_now',
  'home_nav.magazine' = 'home_nav.magazine',
  'home_nav.magazine_and_news' = 'home_nav.magazine_and_news',
  'home_nav.magazine_card_title' = 'home_nav.magazine_card_title',
  'home_nav.magazine_card_description' = 'home_nav.magazine_card_description',
  'home_nav.magazine_card_cta' = 'home_nav.magazine_card_cta',
  'home_nav.magazine_card_image_alt' = 'home_nav.magazine_card_image_alt',
  'home_nav.news_card_title' = 'home_nav.news_card_title',
  'home_nav.news_card_description' = 'home_nav.news_card_description',
  'home_nav.news_card_cta' = 'home_nav.news_card_cta',
  'home_nav.news_card_image_alt' = 'home_nav.news_card_image_alt',
  'home_nav.faq' = 'home_nav.faq',
  'home_nav.other_spirits' = 'home_nav.other_spirits',
  'home_nav.type' = 'home_nav.type',
  'home_nav.all' = 'home_nav.all',
  'home_nav.browse' = 'home_nav.browse',
  'home_nav.type_whisky' = 'home_nav.type_whisky',
  'home_nav.type_wine' = 'home_nav.type_wine',
  'home_nav.type_rum' = 'home_nav.type_rum',
  'home_nav.type_gin' = 'home_nav.type_gin',
  'home_nav.type_champagne' = 'home_nav.type_champagne',
  'home_nav.type_liquor' = 'home_nav.type_liquor',
  'home_nav.brand' = 'home_nav.brand',
  'home_nav.countries' = 'home_nav.countries',
  'home_nav.europe' = 'home_nav.europe',
  'home_nav.asia' = 'home_nav.asia',
  'home_nav.america_caribbean' = 'home_nav.america_caribbean',
  'home_nav.country_scotland' = 'home_nav.country_scotland',
  'home_nav.country_france' = 'home_nav.country_france',
  'home_nav.country_japan' = 'home_nav.country_japan',
  'home_nav.country_taiwan' = 'home_nav.country_taiwan',
  'home_nav.country_usa' = 'home_nav.country_usa',
  'home_nav.country_ireland' = 'home_nav.country_ireland',
  'home_nav.country_england' = 'home_nav.country_england',
  'home_nav.country_australia' = 'home_nav.country_australia',
  'home_nav.country_germany' = 'home_nav.country_germany',
  'home_nav.country_spain' = 'home_nav.country_spain',
  'home_nav.country_italy' = 'home_nav.country_italy',
  'home_nav.country_nordics' = 'home_nav.country_nordics',
  'home_nav.country_india' = 'home_nav.country_india',
  'home_nav.country_china' = 'home_nav.country_china',
  'home_nav.country_korea' = 'home_nav.country_korea',
  'home_nav.country_united_states' = 'home_nav.country_united_states',
  'home_nav.country_canada' = 'home_nav.country_canada',
  'home_nav.country_mexico' = 'home_nav.country_mexico',
  'home_nav.country_jamaica' = 'home_nav.country_jamaica',
  'home_nav.country_guyana' = 'home_nav.country_guyana',
  'home_nav.country_barbados' = 'home_nav.country_barbados',
  'home_nav.country_worldwide' = 'home_nav.country_worldwide',
  'home_nav.region_speyside' = 'home_nav.region_speyside',
  'home_nav.region_islay' = 'home_nav.region_islay',
  'home_nav.region_highland' = 'home_nav.region_highland',
  'home_nav.region_lowland' = 'home_nav.region_lowland',
  'home_nav.region_campbeltown' = 'home_nav.region_campbeltown',
  'home_nav.region_island' = 'home_nav.region_island',
  'home_nav.topics' = 'home_nav.topics',
  'home_nav.topic_new' = 'home_nav.topic_new',
  'home_nav.topic_popular' = 'home_nav.topic_popular',
  'home_nav.topic_release_calendar' = 'home_nav.topic_release_calendar',
  'home_nav.topic_lowest_ask' = 'home_nav.topic_lowest_ask',
  'home_nav.topic_highest_bid' = 'home_nav.topic_highest_bid',
  'home_nav.topic_alphabetical' = 'home_nav.topic_alphabetical',
  'home_nav.type_spirits' = 'home_nav.type_spirits',
  'home_nav.brands' = 'home_nav.brands',
  'home_nav.popular_brands' = 'home_nav.popular_brands',
  'home_nav.classic_brands' = 'home_nav.classic_brands',
  'home_nav.trending_brands' = 'home_nav.trending_brands',
  'home_nav.bourbon_american' = 'home_nav.bourbon_american',
  'home_nav.spirits_rum' = 'home_nav.spirits_rum',
  'home_nav.brand_of_the_month' = 'home_nav.brand_of_the_month',
  'home_nav.show_all_brands' = 'home_nav.show_all_brands',
  'home_nav.shop_now' = 'home_nav.shop_now',
  'home_nav.new_bottles' = 'home_nav.new_bottles',
  'home_nav.new' = 'home_nav.new',
  'home_nav.new_collections' = 'home_nav.new_collections',
  'home_nav.upcoming_releases' = 'home_nav.upcoming_releases',
  'home_nav.explore_spiritory' = 'home_nav.explore_spiritory',
  'home_nav.customer_favorites' = 'home_nav.customer_favorites',
  'home_nav.rare_collectible' = 'home_nav.rare_collectible',
  'home_nav.below_retail' = 'home_nav.below_retail',
  'home_nav.hot_deals' = 'home_nav.hot_deals',
  'home_nav.gift_ideas' = 'home_nav.gift_ideas',
  'home_nav.show_all_new_bottles' = 'home_nav.show_all_new_bottles',
  'home_nav.show_all_upcoming_releases' = 'home_nav.show_all_upcoming_releases',
  'home_nav.new_articles' = 'home_nav.new_articles',
  'home_nav.future_releases' = 'home_nav.future_releases',
  'home_nav.about_spiritory' = 'home_nav.about_spiritory',
  'home_nav.how_it_works' = 'home_nav.how_it_works',
  'home_nav.buyer_guide' = 'home_nav.buyer_guide',
  'home_nav.authentication' = 'home_nav.authentication',
  'home_nav.portfolio_guide' = 'home_nav.portfolio_guide',
  'home_nav.bottle_condition' = 'home_nav.bottle_condition',
  'home_nav.help' = 'home_nav.help',
  'home_nav.your_portfolio' = 'home_nav.your_portfolio',
  'home_nav.sell_on_spiritory' = 'home_nav.sell_on_spiritory',
  'home_nav.become_a_seller' = 'home_nav.become_a_seller',
  'home_nav.seller_guide' = 'home_nav.seller_guide',
  'home_nav.shipping_guide' = 'home_nav.shipping_guide',
}

export { IndexV2Enum };
